import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { statuses } from 'constants/vehicle';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const VehicleStatusSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  omitFields,
  asyncErrors,
  margin,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [defaultValue, setDefaultValue] = useState(null);
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || !value) {
      const defaultVal = statuses.find((status) => status === value);
      if (defaultVal) {
        setDefaultValue(i18n.t(`status.${defaultVal}`));
      } else {
        setDefaultValue(null);
      }
    }
  }, [value, statuses]) // eslint-disable-line

  return (
    <Autocomplete
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      id="vehicle-statuses"
      inputValue={inputValue}
      defaultValue={defaultValue}
      filterOptions={filterOptions}
      onInputChange={(ev, val) => setInputValue(val || '')}
      error={handleError(name, errors, touched, asyncErrors)}
      onChange={(ev, val) => setFieldValue(name, val || '')}
      getOptionLabel={(option) => i18n.t(`status.${option}`, { defaultValue: option })}
      options={statuses.filter((value) => omitFields.indexOf(value))}
      getOptionSelected={(option, value) =>
        i18n.t(`status.${option}`, { defaultValue: option }) === value || ''
      }
      helperText={handleShowError(name, errors, touched, asyncErrors)}
    />
  );
};

VehicleStatusSelect.propTypes = {
  label: PropTypes.string,
  asyncErrors: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  omitFields: PropTypes.array,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

VehicleStatusSelect.defaultProps = {
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  style: {},
  field: {},
  omitFields: [],
  label: 'Status',
  variant: 'standard',
};

export default VehicleStatusSelect;
